import FalconCardHeader from 'components/common/FalconCardHeader';
import React, { useState } from 'react';
import { Button, Card, Form, Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import LoadingButton from 'components/fantaclasse/LoadingButton';
import { toast } from 'react-toastify';
import { queryClient } from 'App';
import { deleteUser } from 'api/userApi';
import { useMutation } from '@tanstack/react-query';
import { useUser } from 'context/UserContext';

const DeleteAccountModal = ({ modalShow, setModalShow }) => {
  const user = useUser();
  const [typedName, setTypedName] = useState('');

  const deleteUserMutation = useMutation({
    mutationFn: deleteUser,
    onSuccess: async () => {
      queryClient.invalidateQueries({ queryKey: ['userData'] });
      toast.success('Il tuo account è stato eliminato con successo!', {
        autoClose: 6000
      });
      toast.success('Grazie per aver giocato al FantaClasse 💙', {
        autoClose: 6000
      });
    },
    onError: err => {
      toast.error(err.response?.data?.message || err.message);
    }
  });

  const handleDeleteUser = async () => {
    deleteUserMutation.mutate();
  };

  return (
    <Modal show={modalShow} onHide={() => setModalShow(false)} centered>
      <Modal.Header className="p-4">
        <Modal.Title>
          <h4 className="mb-0">Elimina il tuo account</h4>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ul className="mb-0">
          <li className="mb-2">
            Tutti i tuoi dati, come <strong>username</strong>,{' '}
            <strong>email</strong> e <strong>password</strong>, verranno
            eliminati.
          </li>
          {user.team?.name && (
            <li className="mb-2">
              La tua squadra <strong>sarà eliminata</strong> e{' '}
              <strong>rimossa dalla classifica</strong>.
            </li>
          )}
          {/* <li className="mb-2">
            Se hai attivo un abbonamento, il pagamento non sarà rimborsato.
          </li> */}
          <li className="mb-2">
            L'eliminazione dell'account è <strong>irreversibile</strong>.
          </li>
        </ul>
        <hr />
        <div className="px-3">
          <h4 className="fs-9">
            Per confermare la tua decisione, scrivi{' '}
            <strong>{user.username}</strong>
          </h4>
          <Form.Control
            value={typedName}
            onChange={e => setTypedName(e.target.value)}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setModalShow(false)}>
          Indietro
        </Button>
        <LoadingButton
          text="Conferma"
          variant="danger"
          isLoading={deleteUserMutation.isPending}
          disabled={typedName !== user.username}
          action={handleDeleteUser}
        />
      </Modal.Footer>
    </Modal>
  );
};

DeleteAccountModal.propTypes = {
  modalShow: PropTypes.bool.isRequired,
  setModalShow: PropTypes.func.isRequired
};

const DangerZone = () => {
  const [modalShow, setModalShow] = useState(false);

  return (
    <Card>
      <DeleteAccountModal modalShow={modalShow} setModalShow={setModalShow} />
      <FalconCardHeader title="Danger Zone" />
      <Card.Body className="bg-body-tertiary">
        <h5 className="mb-0">Elimina questo account</h5>
        <p className="fs-10">
          Una volta eliminato l'account, non sarà più possibile ripristinarlo.
        </p>
        <Button
          variant="falcon-danger"
          className="w-100"
          onClick={() => setModalShow(true)}
        >
          Elimina il tuo account
        </Button>
      </Card.Body>
    </Card>
  );
};

export default DangerZone;
